import {
  SavePasswordDocument,
  SavePasswordMutationResult,
  SavePasswordMutationVariables,
} from "@graphql/api";

interface SavePasswordReturn {
  success: boolean;
  errorMessage?: string;
}

export default async function savePasswordWithPid(
  id: number,
  currentPassword: string,
  newPassword: string
): Promise<SavePasswordReturn> {
  const client = global.window.apolloClient;
  const mutVars: SavePasswordMutationVariables = { id, currentPassword, newPassword };
  const result: SavePasswordMutationResult = await client.mutate({
    mutation: SavePasswordDocument,
    variables: mutVars,
  });

  return result.data.savePassword;
}
